import { useState, useEffect } from 'react'
import { Loading, Button, Toast, Popup } from 'react-vant'
import { useNavigate } from 'react-router-dom'
import teacherAffairsApi from '../../../api/teacherAffairs'

const WEEK = ['一', '二', '三', '四', '五', '六', '日']

export default function AdminPendingSubstitute() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [list, setList] = useState([])
  const [current, setCurrent] = useState(null)   // 正在指派的课时
  const [cands, setCands] = useState([])
  const [candLoading, setCandLoading] = useState(false)
  const [assigning, setAssigning] = useState(false)

  const load = async () => {
    setLoading(true)
    try {
      const res = await teacherAffairsApi.getPendingSubstitutes({ page: 1, page_size: 100 })
      const items = res?.data?.items || res?.items || (Array.isArray(res) ? res : [])
      setList(Array.isArray(items) ? items : [])
    } catch (e) {
      Toast.fail(e.response?.data?.detail || '加载失败')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => { load() }, [])

  // 打开候选
  const openCandidates = async (impact) => {
    setCurrent(impact)
    setCands([])
    setCandLoading(true)
    try {
      const res = await teacherAffairsApi.getSubstituteCandidates(impact.id, 12)
      const items = res?.data || (Array.isArray(res) ? res : [])
      setCands(Array.isArray(items) ? items : [])
    } catch (e) {
      Toast.fail(e.response?.data?.detail || '候选加载失败')
    } finally {
      setCandLoading(false)
    }
  }

  const doAssign = async (c) => {
    if (!c || c.conflict) return
    setAssigning(true)
    try {
      await teacherAffairsApi.createSubstituteAssignment({
        impact_id: current.id,
        substitute_teacher_id: c.teacher_id,
        lesson_count: 1,
      })
      Toast.success(`已指派 ${c.teacher_name}`)
      setCurrent(null)
      load()
    } catch (e) {
      Toast.fail(e.response?.data?.detail || '指派失败')
    } finally {
      setAssigning(false)
    }
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f5f7fa' }}>
      <NavBarSimple title="待安排代课" onBack={() => navigate(-1)} />

      <div style={{ padding: '12px 16px 24px' }}>
        <div style={{
          fontSize: 12, color: '#64748b', marginBottom: 12, lineHeight: 1.6,
          background: '#eff6ff', padding: '8px 10px', borderRadius: 8,
        }}>
          请假审批通过后识别出的待安排课时。点「安排代课」查看候选教师并指派。
        </div>

        {loading ? (
          <div style={{ padding: '40px 0', textAlign: 'center' }}>
            <Loading type="spinner" color="#0891b2">加载中…</Loading>
          </div>
        ) : list.length === 0 ? (
          <div style={{ padding: '60px 0', textAlign: 'center', color: '#94a3b8', fontSize: 14 }}>
            没有待安排的代课
          </div>
        ) : (
          list.map(item => (
            <div key={item.id} style={{
              background: '#fff', borderRadius: 12, padding: 14, marginBottom: 12,
              borderLeft: '3px solid #0891b2',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6, flexWrap: 'wrap' }}>
                <span style={{ fontSize: 14, fontWeight: 600, color: '#0f172a' }}>
                  {item.class_name || '未知班级'}
                </span>
                <span style={{
                  fontSize: 11, color: '#00b578', border: '1px solid #00b578',
                  borderRadius: 4, padding: '0 5px',
                }}>{item.subject_name || '体育'}</span>
                {item.is_pe_class ? (
                  <span style={{
                    fontSize: 11, color: '#0891b2', border: '1px solid #0891b2',
                    borderRadius: 4, padding: '0 5px',
                  }}>体育课</span>
                ) : null}
                <span style={{ fontSize: 12, color: '#94a3b8', marginLeft: 'auto' }}>
                  {item.impact_date} 周{WEEK[(item.day_of_week || 1) - 1]}
                </span>
              </div>
              <div style={{ fontSize: 13, color: '#475569', marginBottom: 4 }}>
                第 {item.period_index} 节 · 请假教师 {item.leave_teacher_name || '—'}
              </div>
              <Button size="small" type="primary" plain style={{ marginTop: 8 }}
                onClick={() => openCandidates(item)}>安排代课</Button>
            </div>
          ))
        )}
      </div>

      {/* 候选教师 */}
      <Popup
        visible={!!current}
        position="bottom"
        round
        height="72%"
        onClose={() => setCurrent(null)}
        title={current ? `安排代课 · ${current.class_name || ''} 第${current.period_index}节` : ''}
      >
        <div style={{ padding: '0 16px 20px' }}>
          {candLoading ? (
            <div style={{ padding: '30px 0', textAlign: 'center' }}>
              <Loading type="spinner" color="#0891b2">加载候选…</Loading>
            </div>
          ) : cands.length === 0 ? (
            <div style={{ padding: '30px 0', textAlign: 'center', color: '#94a3b8' }}>
              没有候选代课教师
            </div>
          ) : (
            cands.map((c, i) => (
              <div
                key={`${c.teacher_id}-${i}`}
                onClick={() => !c.conflict && doAssign(c)}
                style={{
                  padding: '12px 0', borderBottom: '1px solid #f1f5f9',
                  opacity: c.conflict ? 0.5 : 1,
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                  <span style={{ fontSize: 15, fontWeight: 600, color: '#0f172a' }}>
                    {c.teacher_name}
                  </span>
                  {!c.conflict && (
                    <span style={{
                      fontSize: 11, color: '#00b578', border: '1px solid #00b578',
                      borderRadius: 4, padding: '0 5px',
                    }}>推荐分 {c.score}</span>
                  )}
                  {c.conflict && (
                    <span style={{
                      fontSize: 11, color: '#e11d48', border: '1px solid #e11d48',
                      borderRadius: 4, padding: '0 5px',
                    }}>{c.conflict_reason || '有冲突'}</span>
                  )}
                </div>
                <div style={{ fontSize: 12, color: '#64748b', lineHeight: 1.6 }}>
                  {(c.reasons || []).join('、') || '符合代课条件'}
                </div>
              </div>
            ))
          )}
        </div>
      </Popup>
    </div>
  )
}

/** 自绘顶部栏：避免 NavBar 的 leftArrow 布尔传参坑，也避免额外依赖 */
function NavBarSimple({ title, onBack }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 8, padding: '12px 16px',
      background: '#fff', borderBottom: '1px solid #f1f5f9',
    }}>
      <button onClick={onBack} aria-label="返回" style={{
        background: 'none', border: 'none', padding: 0, cursor: 'pointer',
        display: 'flex', alignItems: 'center', color: '#0f172a', fontSize: 20, lineHeight: 1,
      }}>‹</button>
      <span style={{ fontSize: 17, fontWeight: 700, color: '#0f172a' }}>{title}</span>
    </div>
  )
}
